import { pDecimalValidationTest} from '@/components/mixins/ValidatedInput.js';
import { max } from '@vee-validate/rules';
import {dateFormatter} from "@/components/Common/Formatters.js";

export default {
    data() {
        return {
            giftCardConfiguration: {
                type: 'giftcards',
                label: 'Gift Cards',
                importModes: [
                    {value:'add', text:'Add New (Skip when card code already present)'},
                    {value:'update', text:'Update (Skip when card code not present, update when found)'},
                    {value:'addAndUpdate', text:'Add and Update'}
                ],
                sampleNotes: [
                    '"Dates are expected to be in the format YYYY-MM-DD."'
                ],
                fields: [
                    {
                        key: 'CardCode',
                        label: 'Card Code',

                        hasErrorCalculator: value => {
                            return (
                                this.isEmpty(value) || max(value, { length: 52 }) !== true
                            );
                        },
                        rules: 'required|max:52',
                        samples: ['"F75D-4C8B-8812"', '"325F-4A68-B634"', '"564D-4A64-A307"']
                    },
                    {
                        key: 'PIN',
                        label: 'PIN',
                        hasErrorCalculator: value => {
                            return (
                                !this.isEmpty(value) && max(value, { length: 4 }) !== true
                            );
                        },
                        rules: 'max:4',
                        samples: ['"2F82"', '"EC27"', '"A26D"']
                    },
                    {
                        key: 'Status',
                        label: 'Status',
                        hasErrorCalculator: value => {
                            return (
                                !this.isEmpty(value) &&
                                !this.matchesExistingObject(value)
                            );
                        },
                        dataType: 'isActiveOptions',
                        defaultValue: 'Active',
                        rules: 'min_value:0',
                        samples: ['"Active"', '"Inactive"', '""']
                    },
                    {
                        key: 'IssueDate',
                        label: 'Issue Date',
                        hasWarningCalculator: value => {
                            return !this.isEmpty(value) && !this.isValidDate(value);
                        },
                        formatter: dateFormatter,
                        rules: {
                            'valid-date': {
                                isValidDate: this.isValidDate,
                                propertyName: 'IssueDate'
                            }
                        },
                        inputType: 'date',
                        addRowDataToRule: 'valid-date',
                        warningDefault: null,
                        samples: [
                            '""',
                            '"2030-10-09"',
                            '"2028-10-05"'
                        ]
                    },
                    {
                        key: 'ExpirationDate',
                        label: 'Expiration Date',
                        hasWarningCalculator: value => {
                            return !this.isEmpty(value) && !this.isValidDate(value);
                        },
                        formatter: dateFormatter,
                        rules: {
                            'valid-date': {
                                isValidDate: this.isValidDate,
                                propertyName: 'ExpirationDate'
                            }
                        },
                        inputType: 'date',
                        addRowDataToRule: 'valid-date',
                        warningDefault: null,
                        samples: [
                            '""',
                            '"2030-10-09"',
                            '"2028-10-05"'
                        ]
                    },
                    {
                        key: 'AvailableFunds',
                        label: 'Available Funds',
                        hasErrorCalculator: value => {
                            return (
                                !this.isEmpty(value) &&
                                !pDecimalValidationTest(value, {
                                    precision: '10',
                                    scale: '2'
                                })
                            );
                        },
                        rules: 'p-decimal:10,2',
                        defaultValue: 0,
                        convertToNumber: true,
                        formatter: (value) => this.isEmpty(value) ? 0 : value,
                        samples: ['0', '75.00', '34.71']
                    },
                    {
                        key: 'CardComment',
                        label: 'Card Comment',
                        hasErrorCalculator: value => {
                            return (
                                !this.isEmpty(value) &&
                                max(value, { length: 2000 }) !== true
                            );
                        },
                        rules: {
                            max: {length: 2000}
                        },
                        samples: ['""','"Spend 100 Get 10 Promo"','"Reissue for lost card"']
                    }                    
                ]
            }
        };
    },
    methods: {}
};
